<template>
    <div id="app">
        <main role="main" class="main-cont">
            <div class="row m-0 main-section">
                <div class="col-sm-12 right-section homebody">
                    <div class="row" style="margin-top:30px;">
                        <div class="col-sm-2 ">
                        </div>
                        <div class="col-sm-8 card bg-light">
                            <div class="row" style="margin-top: 20px;margin-bottom: 20px;">
                                <div class="col">
                                    <h4 class="mb-4">
                                        <span v-if = "selectedReport == 'ACRReport'">ACR</span>
                                        <span v-if = "selectedReport == 'CITReport'">CIT</span>
                                        Transactions Report
                                    </h4>
                                    <div class="panelDiv">
                                        <div v-if="loading" class="spinner__icon spinner__icon--xxlarge spinner_position">
                                        </div>
                                        <div class="col-sm-12" style="margin: 10px">
                                            <!--
                                            <div class="col-sm-6 col-md-6">
                                                <h6 class="mb-3 subHeader">Select Transaction Report Category</h6>
                                            </div>
                                            <div class="col-sm-7 col-md-7">
                                                <select class="form-control selectarrow"
                                                        aria-label="Select Transaction Report Category"
                                                        title="Report Name"
                                                        v-model="selectedReport"
                                                        v-on:change="onReportChange()"
                                                        name="reportName">
                                                        <option v-for="option in options" :value="option.value"  :key="option.value">
                                                            {{ option.text }}
                                                        </option>
                                                </select>
                                               selectedReport: {{ selectedReport }}
                                            </div>   
                                            <br/>
                                            -->
                                            <div class="d-flex">
                                                <div class="col-sm-6 col-md-5 col-5">
                                                    <h6 class="mb-3 subHeader">From Date</h6>
                                                    <input type="date"
                                                        class="form-control border input-control-border"
                                                        id="fromdate"
                                                        v-model="FromDt"
                                                        title="From Date Picker"
                                                        placeholder="Select a date"
                                                        aria-label="User Cursor to navigate, enter to select and esc to close"
                                                        name="fromdate"
                                                        v-on:change="onFromDateChange()"
                                                    />
                                                </div>   
                                                <div class="col-sm-6 col-md-5 col-5">
                                                    <h6 class="mb-3 subHeader">Till Date</h6>
                                                    <input type="date"
                                                        class="form-control border input-control-border"
                                                        id="tilldate"
                                                        v-model="TillDt"
                                                        title="Till Date Picker"
                                                        placeholder="Select a date"
                                                        aria-label="User Cursor to navigate, enter to select and esc to close"
                                                        name="tilldate"
                                                        v-on:change="onTillDateChange()"
                                                    />
                                                </div>
                                                <div>
                                                <button v-on:click="onSubmit()" id="btnResult"
                                                    type="button"
                                                    class="btn btn-primary">
                                                    Show results
                                                </button>
                                            </div>  
                                            </div>  
                                        </div>
                                        <div class="container">
                                                <div class="modal" id="savingsModal">
                                                    <div class="modal-dialog">
                                                        <div class="modal-content" style="width: 715px">
                                                            <div class="modal-header">
                                                                <h5 class="modal-title">Savings</h5>
                                                                <button type="button" id="btnCalcId" class="close" aria-label="Close" v-on:click="closeSavingsModal()">
                                                                    <span aria-hidden="true">&times;</span>
                                                                </button>
                                                            </div>
                                                            <div class="modal-body">
                                                                <div class="d-flex">
																<div>
																	<select class="form-control selectarrow custom_width"
                                                                        aria-label="Select File Type"
                                                                        title="Selected File Type"
                                                                        v-model="selectedType"
                                                                        v-on:change="onTypeChange()"
                                                                        name="reportName">
                                                                        <option value="" disabled selected hidden>Choose a File Type</option>
																		<option v-for="item in options" :value="item"  :key="item">
																			{{ item }}
																		</option>
																	</select>
																</div>
																&nbsp;
																<div>
                                                                    <input class="custom_width" type="number" v-model="typeCount" placeholder="Count" disabled>
                                                                </div>
																&nbsp;
																<div>*</div>
																&nbsp;
																<div>1.8</div>
																&nbsp;
																<div>*</div>
																&nbsp;
																<div>
																	<input class="custom_width" type="number" v-model="savingsInput" placeholder="Amount" v-on:input="onSavingsInputChange()">
																</div>
																&nbsp;
																<div>=</div>
																&nbsp;
																<div>
																	<input class="custom_width" type="number" v-model="totalAmount" placeholder="Total Amount" disabled> 
																</div>
															</div>
                                                            </div>
                                                            <div class="modal-footer">
                                                                <button type="button" class="btn btn-primary" v-on:click="clearSavingsModal()">Clear Fields</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        <div class="container" v-if="transactions.length">
                                            <!--<div>-->
                                                <button v-on:click="openSavingsModal()" id="btnSavings"
                                                    type="button"
                                                    class="btn btn-primary action_btn">
                                                    Savings
                                                </button>
                                            <!--</div>-->
                                            <!--<div>-->
                                                <button v-on:click="exportToExcel()" id="btnExport"
                                                    type="button"
                                                    class="btn btn-primary action_btn">
                                                    <font-awesome-icon :icon="['fas', 'download']" class="icon download" style="width:15px;height:10px;" />
                                                    Export
                                                </button>
                                            <!--</div>-->
                                        </div>
                                        <div class="container">
                                            <div class="row col-sm-12" v-if="selectedReport == 'ACRReport'" >
                                                <div class="col">
                                                    <table
                                                        id="acr-user-table"
                                                        class="table table-striped display table-bordered nowrap"
                                                        cellspacing="0"
                                                        width="100%">
                                                        <thead>
                                                            <tr>
                                                                <th>Client Name</th>
                                                                <th>Bank Name</th>
                                                                <th>File Type</th>
                                                                <th>File Name</th>
                                                                <th>Processed By</th>
                                                                <th>Active</th>
                                                                <th>Created On</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="row col-sm-12"  v-if="selectedReport == 'CITReport'">
                                                <div class="col">
                                                    <table
                                                        id="cit-user-table"
                                                        class="table table-striped display table-bordered nowrap"
                                                        cellspacing="0"
                                                        width="100%">
                                                        <thead>
                                                            <tr>
                                                                <th>Client Name</th>
                                                                <th>File Type</th>
                                                                <th>File Name</th>
                                                                <th>Processed By</th>
                                                                <th>Active</th>
                                                                <th>Created On</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import CommonService from '../../services/SharedService/common.service.js';
    import $ from 'jquery';
    export default {
        name: 'TransactionReports',
        mixins: [CommonService],
        data: () => ({
            selectedReport: "ACRReport",
            FromDt: "",
            TillDt: "",
            loading: false,
            showTable: true,
            acrTableData: null,    
            citTableData: null,    
            options: [],
            typeCount: null,
            savingsInput: null,
            totalAmount: null,
            transactions: [],
            selectedType: ""

            // options: [
            //     { text: 'ACR Transactions Report', value: 'ACRReport'},
            //     { text: 'CIT Transactions Report', value: 'CITReport'}
            // ]
        }),
        methods: {
            onReportChange() {
                this.FromDt = "";
                this.acrTableData.clear().draw();
                this.citTableData.clear().draw();
                //this.showTable = false;
            },

            onFromDateChange() {
                //alert(this.FromDt)
            },

            onTillDateChange() {
                //alert(this.TillDt)                
            },

            onTypeChange() {
                this.typeCount = this.transactions.filter(item => item.fileType == this.selectedType).length;
            },

            openSavingsModal() {
                $('#savingsModal').modal('show');
            },

            closeSavingsModal() {
                this.clearSavingsModal();
                $('#savingsModal').modal('hide');
            },

            clearSavingsModal() {
                this.selectedType = "";
                this.typeCount = 0;
                this.savingsInput = 0;
                this.totalAmount = 0;                
            },

            onSavingsInputChange() {
               this.totalAmount = this.typeCount * 1.8 * this.savingsInput
            },

            onSubmit() {
                //this.showTable = true;
                this.loading = true;
                if(this.selectedReport && this.FromDt && this.TillDt) {
                    // this.acrTableData.clear().draw();
                    // this.citTableData.clear().draw();
                    this.setTableData()
                }
            },

            setTableData() {
                $.fn.dataTable.ext.errMode = 'none';

                //if(!this.acrTableData) {
                    this.acrTableData = $("#acr-user-table").DataTable({
                        "order": [],
                        "pageLength": 50,
                        "columnDefs": [
                            {
                                "targets": [],
                                "visible": false,
                                "searchable": false
                            }
                        ]
                    });
                //}

                //if(!this.citTableData) {
                    this.citTableData = $("#cit-user-table").DataTable({
                        "order": [],
                        "pageLength": 50,
                        "columnDefs": [
                            {
                                "targets": [],
                                "visible": false,
                                "searchable": false
                            }
                        ]
                    });
                //}

                this.getTransactionsReport(this.selectedReport, this.FromDt, this.TillDt).then(result => {
                    this.loading = false;
                        if(result && result.data.length) {
                            this.transactions = result.data;
                            var selection = this.selectedReport;
                            var options = [];
                            this.transactions.forEach(item => {
                                if(options.indexOf(item.fileType) < 0) {
                                    options.push(item.fileType)
                                }

                                if(selection == "ACRReport") {
                                    this.acrTableData.row
                                        .add([item.clientName, 
                                              item.bankName,
                                              item.fileType,
                                              item.fileName,
                                              item.userName, 
                                              (item.isActive == true) ? 'Yes' : 'No', 
                                              item.createdOn])
                                        .draw();
                                }
                                else if(selection == "CITReport") {
                                    this.citTableData.row
                                        .add([item.clientName,
                                              item.fileType,
                                              item.fileName,
                                              item.userName, 
                                              (item.isActive == true) ? 'Yes' : 'No', 
                                              item.createdOn])
                                        .draw();
                                }
                            })
                            this.options = options;
                        }
                    }
                )
            },

            exportToExcel() {
                 // Variable to store the final csv data
                var csv_data = [];
            
                // Get each row data
                var rows = document.getElementsByTagName('tr');
                for (var i = 0; i < rows.length; i++) {
            
                    // Get each column data
                    var cols = rows[i].querySelectorAll('td,th');
            
                    // Stores each csv row data
                    var csvrow = [];
                    for (var j = 0; j < cols.length; j++) {
            
                        // Get the text data of each cell of
                        // a row and push it to csvrow
                        csvrow.push(cols[j].innerHTML);
                    }
            
                    // Combine each column value with comma
                    csv_data.push(csvrow.join(","));
                }
                // combine each row data with new line character
                csv_data = csv_data.join('\n');

                var CSVFile = new Blob([csv_data], {
                     type: "text/csv"
                });
 
                // Create to temporary link to initiate
                // download process
                var temp_link = document.createElement('a');
    
                // Download csv file
                temp_link.download = "TransactionsReport.csv";
                var url = window.URL.createObjectURL(CSVFile);
                temp_link.href = url;
    
                // This link should not be displayed
                temp_link.style.display = "none";
                document.body.appendChild(temp_link);
    
                // Automatically click the link to
                // trigger download
                temp_link.click();
                document.body.removeChild(temp_link);
            }
        },

        beforeMount() {
            this.selectedReport = this.$route.params.report

            let setFromDt = new Date();
            let setTillDt = new Date();

            setFromDt.setMonth(setFromDt.getMonth() - 1);
            this.FromDt = setFromDt.getFullYear()  + '-' 
                            + ("0" + (setFromDt.getMonth() + 1)).slice(-2) + '-' 
                            + ("0" + setFromDt.getDate()).slice(-2)

            this.TillDt = setTillDt.getFullYear()  + '-' 
                            + ("0" + (setTillDt.getMonth() + 1)).slice(-2) + '-' 
                            + ("0" + setTillDt.getDate()).slice(-2)
        },

        mounted() {
            this.setTableData();
        }
    }
</script>
<style>
    .action_btn {
        float: right;
        margin: 10px;
    }

    .no_wrap {
        white-space: break-spaces;
    }

    table.table-bordered.dataTable td {
        white-space: break-spaces !important;
    }

    #btnResult {
        margin: 25px 0px 0px 20px;
    }

    .custom_width {
        width: 150px;
    }
</style>